module.exports = __webpack_public_path__ + "static/media/Iraq.94ff6887.png";